import { render, staticRenderFns } from "./ListRate.vue?vue&type=template&id=4d15b212&"
import script from "./ListRate.vue?vue&type=script&lang=js&"
export * from "./ListRate.vue?vue&type=script&lang=js&"
import style0 from "./ListRate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports